import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  intro?: string;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'light',
  align = 'left'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-49" data-mp="3jzdnkmhuhqcy">
      <p className={`text-sm tracking-wider2 ${isDark ? 'text-gold-300' : 'text-grass-600'}`} data-id="element-50" data-mp="bjtylzo7iu3p">
        {eyebrow}
      </p>
      <h2 className={`mt-3 text-3xl leading-tight md:text-[2.6rem] ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-51" data-mp="gix4tnfxb6d9">
        {title}
      </h2>
      <div className={align === 'center' ? 'rule-gold mx-auto mt-5' : 'rule-gold mt-5'} data-id="element-52" data-mp="6svd8lod35tl" />
      {intro ? <p className={`mt-6 text-lg leading-relaxed ${isDark ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-53" data-mp="ui6gqax3jebf">
          {intro}
        </p> : null}
    </div>;
}